class ProductSelector extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {

    if (this.initialised){
      return;
    }

    this.bindElements();

    if (!this.tabs){
      console.error('No Tabs to initialise');
      return;
    }

    this.bindData();
    this.bindEvents();

    this.dispatchEvent(new CustomEvent('ProductSelector:ready', { bubbles: true }));
    this.initialised = true;
  }

  bindEvents() {
    const self = this;
    this.tabButtons.forEach(function(button){
      button.addEventListener('click',function(){
        self.handleTabSelection(button);
      });
    })
  }

  handleTabSelection(button) {
    const self = this;
    const tabId = button.dataset.id;
    const tabContent = this.querySelector('[data-id="'+tabId+'"].tab-content');
    if (tabContent){
      self.hideAllTabs();

      tabContent.classList.add('active');
      button.classList.add('active');
      const matchingSize = tabContent.querySelector('[data-size="'+self.selectedSize+'"]');
      if (matchingSize){
        self.unselectSizes();
        matchingSize.classList.add('is-selected');
        matchingSize.click();
      }
    }
  }
  unselectSizes() {
    const self = this;
    self.sizes.forEach(function(size){
      size.classList.remove('is-selected');
    });
  }

  hideAllTabs() {
    const self = this;
    self.tabContents.forEach(function(content){
      content.classList.remove('active');
    });
    this.tabButtons.forEach(function(button){
      button.classList.remove('active');
    });
  }

  bindElements() {
    this.tabs = this.querySelector('.tabs');
    this.tabButtons = this.querySelectorAll('.tab-button');
    this.tabContents = this.querySelectorAll('.tab-content');
    this.sizes = this.querySelectorAll('.product-swatch');

    this.selectedTab = this.querySelector('.tab-button.active');
    this.selectedSizeContent = this.querySelector('.product-swatch.is-selected');
  }

  bindData() {
    const self = this;
    self.selectedStyle = this.selectedTab.dataset.style
    self.selectedSize = this.selectedSizeContent.dataset.size
  }

}

customElements.define('product-selector', ProductSelector);


class BulkQuantity extends HTMLElement {
  constructor() {
    super();

    this.currentQuantity = 1;
  }

  connectedCallback() {

    if (this.initialised){
      return;
    }

    this.bindElements();

    if (!this.accordion){
      console.error('No accordion to initialise');
      return;
    }

    this.bindData();

    if (!this.discounts){
      console.error('Unable to read discounts');
      return;
    }

    this.bindEvents();

    this.dispatchEvent(new CustomEvent('BulkQuantity:ready', { bubbles: true }));
    this.initialised = true;

    // Set initial ARIA attributes
    this.accordionTitle.setAttribute('role', 'button');
    this.accordionTitle.setAttribute('aria-expanded', 'false');
    this.accordionTitle.setAttribute('aria-controls', this.accordionContent.id || 'bulk-discount-list');
    this.accordionContent.setAttribute('aria-hidden', 'true');
  }

  bindElements() {
    this.accordion = this.querySelector('.accordion');
    this.accordionTitle = this.querySelector('.accordion__toggle');
    this.accordionContent = this.querySelector('.accordion__content');

    this.discountItems = this.querySelectorAll('.bulk-discount');
    this.quantitySelector = this.querySelector('.quantity-selector__input');

    this.upsellMessage = this.querySelector('[data-upsell-message]');
    this.currentDiscount = this.querySelector('.bulk-discount.active');

    this.dataContainer = this.querySelector('.quantity-discounts-data');
    this.discountBadge = this.querySelector('[data-discount-amount]');
    this.announcement = document.getElementById('quantity-announcement');
  }

  bindData() {
    const self = this;
    self.discount = 0;
    self.quantity = this.quantitySelector.value;
    self.discountMessageTemplate = this.upsellMessage.dataset.upsellMessage;

    try {
      self.discounts = JSON.parse(self.dataContainer.innerHTML);
    }
    catch(e){
      console.log(e);
    }
  }

  bindEvents() {
    const self = this;
    this.discountItems.forEach(function(discount){
      discount.addEventListener('click',function(){
        const quantity = discount.dataset.quantity;
        self.updateQuantitySelector(quantity);
        self.updateMessaging();
      });

      discount.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          discount.click();
        }

        // Close accordion with Escape key
        if (e.key === 'Escape') {
          self.closeAccordion();
          self.accordionTitle.focus(); // Return focus to the accordion toggle
        }
      });
    });

    this.accordionTitle.addEventListener('click',function(){
      self.handleTitleClick();
    });
    this.accordionTitle.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        self.handleTitleClick();
      }
      if (e.key === 'Escape') {
        self.closeAccordion();
        self.accordionTitle.focus();
      }
    });

    this.quantitySelector.addEventListener('change',function(event){
      self.currentQuantity = self.quantitySelector.quantity;
      self.updateMessaging();
    });

    self.onPageLoad();
  }

  updateQuantitySelector(quantity) {
    const self = this;
    self.quantitySelector.value = parseInt(quantity);
    self.currentQuantity = parseInt(quantity);
    self.quantitySelector.dispatchEvent(new Event("change", { bubbles: true }));
    self.quantitySelector.blur();

    self.announcement.textContent = `Quantity updated to ${self.currentQuantity}`;
  }

  onPageLoad() {
    const self = this;
    self.updateMessaging();
  }

  getNextDiscount() {
    const self = this;
    self.discounts.forEach(function(discount,index){
      if (self.currentQuantity >= parseInt(discount.quantity)){
        self.discountIndex = index;
      }
    });
  }

  updateMessaging() {
    const self = this;
    self.getNextDiscount();
    let nextDiscountIndex = self.discountIndex + 1;
    let discountMessage = '';
    if (nextDiscountIndex > (self.discounts.length - 1)){
      discountMessage = '';
    }
    else {
      let nextQuantity = self.discounts[self.discountIndex + 1].quantity;
      let nextDiscount = self.discounts[self.discountIndex + 1].discount;
      let currentDiscount = self.discounts[self.discountIndex].discount;
      let currentQuantity = self.currentQuantity;
      let differenceQuantity = (parseInt(self.discounts[self.discountIndex + 1].quantity)) - self.currentQuantity;
      discountMessage = (''+self.discountMessageTemplate+'').split('{next_quantity}', ).join(nextQuantity)
      discountMessage = discountMessage.split('{next_discount}', ).join(nextDiscount)
      discountMessage = discountMessage.split('{current_quantity}', ).join(currentQuantity)
      discountMessage = discountMessage.split('{current_discount}', ).join(currentDiscount)
      discountMessage = discountMessage.split('{difference_quantity}', ).join(differenceQuantity)
    }
    self.selectButton();
    if (self.discounts[self.discountIndex].discount == "0%"){
      self.discountBadge.innerText = '';
    }
    else {
      self.discountBadge.innerText = self.discounts[self.discountIndex].discount;
    }

    self.upsellMessage.innerText = discountMessage;
  }

  selectButton(){
    const self = this;
    let button = self.querySelectorAll('.bulk-discount')[self.discountIndex - 1];
    if (button){
      self.deselectAllButtons();
      button.classList.add('active');
    }
  }

  deselectAllButtons (){
    const self = this;
    self.discountItems.forEach(function(item){
      item.classList.remove('active');
    });
  }

  handleTitleClick() {
    const self = this;
    const isExpanded = self.accordionTitle.getAttribute('aria-expanded') === 'true';
    self.accordionTitle.setAttribute('aria-expanded', !isExpanded);
    self.accordionContent.hidden = isExpanded;

    if (!isExpanded) {
      self.accordion.classList.add('active');
    } else {
      self.accordion.classList.remove('active');
    }
  }

  openAccordion() {
    const self = this;
    self.accordion.classList.add('active');
    this.accordionTitle.setAttribute('aria-expanded', 'true');
    this.accordionContent.setAttribute('aria-hidden', 'false');

    this.discountItems.forEach(item => item.setAttribute('tabindex', '0'));

    // Focus the first bulk discount item
    const firstItem = self.discountItems[0];
    if (firstItem) {
      firstItem.focus();
    }
  }

  closeAccordion() {
    const self = this;
    self.accordion.classList.remove('active');
    self.accordionTitle.setAttribute('aria-expanded', 'false');
    self.accordionContent.setAttribute('aria-hidden', 'true');

    this.discountItems.forEach(item => item.setAttribute('tabindex', '-1'));
  }

}

customElements.define('bulk-quantity', BulkQuantity);

class ProductUpsells extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.initialised) return;

    this.bindElements();
    this.bindData();
    this.bindEvents();

    this.dispatchEvent(new CustomEvent('ProductUpsells:ready', { bubbles: true }));
    this.initialised = true;
  }

  bindElements() {
    this.addToCartButtons = this.querySelectorAll('.upsell-item__actions');
    this.announcementRegion = document.getElementById('upsell-announcement');
  }

  bindData() {
    // Placeholder for future data bindings if needed
  }

  bindEvents() {
    this.addToCartButtons.forEach(button => {
      button.addEventListener('click', () => this.toggleUpsell(button));
    });
  }

  toggleUpsell(button) {
    const gridItem = button.closest('.upsell-item');
    const input = gridItem.querySelector('.upsell-input');
    const productTitle = button.getAttribute('data-product-title');
    const productPrice = button.getAttribute('data-product-price');
    const productDiscount = button.getAttribute('data-product-discount');

    if (gridItem.classList.contains('added')) {
      // Remove product
      gridItem.classList.remove('added');
      input.disabled = true;

      // Update aria-label and announce
      button.setAttribute('aria-label', `Add ${productTitle} for ${productDiscount}`);
    } else {
      // Add product
      gridItem.classList.add('added');
      input.disabled = false;

      // Update aria-label and announce
      button.setAttribute('aria-label', `Unselect ${productTitle}`);
    }
  }

  announce(message) {
    // Clear previous announcement
    this.announcementRegion.textContent = '';
    setTimeout(() => {
      this.announcementRegion.textContent = message;
    }, 100); // Timeout ensures screen readers catch the change
  }
}

customElements.define('product-upsells', ProductUpsells);


class SiteSlider extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {

    if (this.initialised){
      return;
    }

    this.bindElements();

    if (!this.sliderContainer){
      console.error('No slider to initialise');
      return;
    }

    this.bindData();

    this.bindEvents();

    this.dispatchEvent(new CustomEvent('ProductUpsells:ready', { bubbles: true }));
    this.initialised = true;
  }

  bindEvents() {
    const self = this;
    self.onPageLoad();
  }

  onPageLoad() {
    const self = this;

    if (this.dataset.async == "true"){
      if (this.slidesHolder.children.length > 0){
        self.initSlider();
        let parent = this.closest('.recently-viewed-products');
        if (parent){
          parent.classList.remove('no-slides');
        }
      }
      else {
        let parent = this.closest('.recently-viewed-products');
        if (parent){
          parent.classList.add('no-slides');
        }
      }
    }
    else {
      self.initSlider();
    }

  }

  initSlider() {
    const self = this;

    let slidesPerViewMobile = 1;
    let slidesPerViewDesktop = 1;

    let nextEl = self.querySelector('.button--next');
    let prevEl = self.querySelector('.button--prev');

    const baseSliderConfig = {
      watchOverflow: true,
      breakpoints: {
        320: {
          slidesPerView: slidesPerViewMobile,
        },
        640: {
          slidesPerView: slidesPerViewDesktop,
        }
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      }
    };

    self.slider = new Swiper(self.sliderContainer, baseSliderConfig);
  }

  bindElements() {
    this.sliderContainer = this.querySelector('.swiper');
    this.slidesHolder = this.querySelector('.upsell-items');
  }

  bindData() {
    const self = this;
  }
}

customElements.define('site-slider', SiteSlider);

class BundleCollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.initialised){
      return;
    }

    this.bindEvents();
    this.initialised = true;
  }

  bindEvents() {
    this.atcBtns = this.querySelectorAll('[data-bundle-atc-btn]')

    // update progress bar
    this.setImages();
    this._checkCart();

    this.atcBtns.forEach((btn) => {
      if (!btn.classList.contains('active')) {
        btn.addEventListener('click', () => this.toggleForm(btn.parentElement));
      }
    });
  }

  toggleForm(bundleATC) {
    if (!bundleATC.classList.contains('disabled')) {
      const activeEl = bundleATC.querySelector('bundle-atc.active');

      if (activeEl) {
        activeEl.classList.remove('active');
      }
      bundleATC.classList.add('active');

      // If first time adding to cart, automatically add one to cart
      this._updateQuantity(bundleATC);
      this._onAdd(bundleATC);
    };
  }

  async _checkCart() {
    let cartItemMatchQ = 1;
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

    cartContent.items.forEach((item) => {
      const currAdded = this.querySelector(`[data-bundle-atc][data-variant-id="${item.id}"]`);
      if (currAdded) {
        cartItemMatchQ += item.quantity;
        currAdded.classList.add('active');
        currAdded.querySelector('.quantity-selector input[name="count"]').value = parseInt(item.quantity);

        this._updateQuantity(currAdded)
      }
    });
  }

  async _updateQuantity(currAdded) {
    const decreaseBtn = currAdded.querySelector('.quantity-selector button[aria-label="Decrease quantity"');
    const increaseBtn = currAdded.querySelector('.quantity-selector button[aria-label="Increase quantity"');

    // If click increase, it should add one product at a time.
    increaseBtn.addEventListener('click', () => {
      this._onAdd(currAdded);
    });

    // If click decrease, it should remove one product at a time.
    decreaseBtn.addEventListener('click', () => {
      this._onRemove(currAdded);
    });
  }

  async _onRemove(bundleATC) {
    let eligibleProducts = JSON.parse(localStorage.getItem('bundleProducts')) ? JSON.parse(localStorage.getItem('bundleProducts')) : {tier: 0, products:[],};
    let quantity = 0;
    this.lineKey = null;
    this.bundleATC = bundleATC;
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    const variantID = this.bundleATC.getAttribute('data-variant-id');
    const inputQuantity = this.bundleATC.querySelector('.quantity-selector input[name="count"]');

    for (let i = 0; i < cartContent.items.length; i++) {
      const item = cartContent.items[i];
      if (item.id === parseInt(variantID)) {
        this.lineKey = item.key;
        quantity = parseInt(item.quantity) - 1;
      }
      break;
    };

    // Update localstorage
    eligibleProducts.products.forEach((product, idx) => {
      if (product.key === this.lineKey) {
        eligibleProducts.products.splice(idx, 1)
      }
    });

    // set tier
    const tierNumber = parseInt(window.theme.settings.bundleTotalTier);
    if ((eligibleProducts.products.length <= 3 && tierNumber > 1) || tierNumber === 1) {
      eligibleProducts.tier = 1;
    } else if (eligibleProducts.products.length > 3 && ((eligibleProducts.products.length <= 5 && tierNumber > 2) || tierNumber === 2)) {
      eligibleProducts.tier = 2;
    } else if (eligibleProducts.products.length > 5 && ((eligibleProducts.products.length <= 7 && tierNumber > 3) || tierNumber === 3)) {
      eligibleProducts.tier = 3;
    } else if (eligibleProducts.products.length > 7) {
      eligibleProducts.tier = 4;
    } else if (eligibleProducts.products.length === 0) {
      eligibleProducts.tier = 0;
    }

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

    const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: this.lineKey,
        quantity: parseInt(quantity),
        sections: sectionsToBundle
      })
    });

    const responseJson = await response.json();
    const messageContainer = this.bundleATC.parentElement.querySelector('.cart-messages');

    if (response.ok) {
      inputQuantity.value = parseInt(quantity);
      messageContainer.innerHTML = `<p class="success">${quantity} in cart</p>`;

      if (parseInt(quantity) === 0) {
        this.bundleATC.classList.remove('active');
      }

      // Update localstorage
      localStorage.setItem('bundleProducts', JSON.stringify(eligibleProducts));

      this.setImages();

      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];

      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));

      setTimeout(() => {
        messageContainer.innerHTML = '';
      }, 3000);

    } else if (response.status == 422) {
      messageContainer.innerHTML = `<p class="error">${response.description}</p>`;

      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));

      setTimeout(() => {
        messageContainer.innerHTML = '';
      }, 3000);
    }
  }

  async _onAdd(bundleATC) {
    this.bundleATC = bundleATC;
    const variantID = this.bundleATC.getAttribute('data-variant-id');
    const inputQuantity = this.bundleATC.querySelector('.quantity-selector input[name="count"]');

    const formData = new FormData(this.bundleATC.parentElement);

    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", `${Shopify.routes.root}variants/${variantID}`);
    formData.set("quantity", 1);

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // Needed for Shopify to check inventory
      }
    });

    const responseJson = await response.json();
    const messageContainer = this.bundleATC.parentElement.querySelector('.cart-messages');

    if (response.ok) {
      inputQuantity.value = parseInt(responseJson.quantity);
      messageContainer.innerHTML = `<p class="success">${responseJson.quantity} successfully added!</p>`;

      this._updateProgress(bundleATC, responseJson);

      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }

      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));

      setTimeout(() => {
        messageContainer.innerHTML = '';
      }, 3000);

    } else if (response.status == 422) {
      messageContainer.innerHTML = `<p class="error">${response.description}</p>`;

      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));

      setTimeout(() => {
        messageContainer.innerHTML = '';
      }, 3000);
    }
  }

  async _updateProgress(bundleATC, item) {
    const bundleCollections = window.theme.settings.bundleCollections;
    const collectionList = bundleCollections !== null ? bundleCollections.split(',') : [];
    let eligibleProducts = JSON.parse(localStorage.getItem('bundleProducts')) ? JSON.parse(localStorage.getItem('bundleProducts')) : {tier: 0, products:[],};
    this.bundleBar = this.querySelector('.collection-bundle__progress-bar');

    // on add to cart
    if (bundleCollections !== null && bundleATC) {
      // check if eligible for bundle then update local storage and progress bar
      const list = bundleATC.getAttribute('data-collection-list');
      this.list = list?.split(',');
      const eligible = this.list.filter((i) => collectionList.includes(i));

      console.log(bundleATC.getAttribute('data-collection-list'), 'bundleATC.getAttribute(\'data-collection-list\')')
      if (eligible.length > 0 && eligible) {
        const productInfo = {
          key: item.key,
          handle: item.handle,
          id: item.id,
          title: item.title,
          price: item.original_price,
          image: item.image
        }
        eligibleProducts.products.push(productInfo);

        const firstEmptyBox = this.bundleBar.querySelectorAll('.progress-bar__box[data-activate="false"]')[0];
        if (firstEmptyBox) {
          firstEmptyBox.setAttribute('data-activate', true);
          firstEmptyBox.querySelector('p').innerHTML = `
            <img src="${item.image}" alt="${item.title}" width="100" height="100%" loading="lazy" />
          `;
        };
        // set tier
        const tierNumber = parseInt(window.theme.settings.bundleTotalTier);
        if ((eligibleProducts.products.length <= 3 && tierNumber > 1) || tierNumber === 1) {
          eligibleProducts.tier = 1;
        } else if (eligibleProducts.products.length > 3 && ((eligibleProducts.products.length <= 5 && tierNumber > 2) || tierNumber === 2)) {
          eligibleProducts.tier = 2;
        } else if (eligibleProducts.products.length > 5 && ((eligibleProducts.products.length <= 7 && tierNumber > 3) || tierNumber === 3)) {
          eligibleProducts.tier = 3;
        } else if (eligibleProducts.products.length > 7) {
          eligibleProducts.tier = 4;
        } else if (eligibleProducts.products.length === 0) {
          eligibleProducts.tier = 0;
        }

        localStorage.setItem('bundleProducts', JSON.stringify(eligibleProducts));

        this.setPrice(eligibleProducts);
        this.updateMessaging(eligibleProducts);
        this.updateCartProgressBar();
      }
    }
  }

  setImages() {
    this.bundleBar = this.querySelector('.collection-bundle__progress-bar');
    const bundle = JSON.parse(localStorage.getItem('bundleProducts'));

    if (bundle?.products) {
      const count = bundle.products.length;
      const boxes = this.bundleBar.querySelectorAll('.progress-bar__box');

      for (let i = 0; i < boxes.length; i++) {
        const boxCount = boxes[i].getAttribute('data-count');

        if (boxCount <= count) {
          boxes[i].setAttribute('data-activate', true);
          boxes[i].querySelector('p').innerHTML = `
            <img src="${bundle.products[i].image}" alt="${bundle.products[i].title}" width="100" height="100%" loading="lazy" />
          `;
        } else {
          // On load if does not apply set to deactivate
          boxes[i].setAttribute('data-activate', false);
          if (!boxes[i].classList.contains('discount-box')) {
            boxes[i].querySelector('p').innerText = boxCount;
          } else {
            boxes[i].querySelector('p').innerHTML = '';
          }
        }
      }
      this.setPrice(bundle);
      this.updateMessaging(bundle);
    }
    this.updateCartProgressBar();
  }

  setPrice(bundleObj) {
    const priceEl = this.querySelector('.collection-bundle__progress-bar .price');
    const discounts = window.theme.settings.bundleDiscountsPercentage.split(',');
    let total = 0;
    let totalPrice = 0;

    if (discounts !== null) {
      bundleObj.products.forEach((product) => {
        total += product.price
      });

      if (bundleObj.products.length >= 3) {
        const idx = bundleObj.products.length >= 9 ? 3 : bundleObj.products.length >= 7 ? 2 : bundleObj.products.length >= 5 ? 1 : 0;
        totalPrice = (total * (100 - discounts[idx])) / 100;
      } else {
        totalPrice = total;
      }
    }

    const price = Number.parseFloat(totalPrice / 100).toFixed(2);
    priceEl.innerHTML = `$${price}`;
  }

  updateMessaging(bundleObj) {
    const productCount = bundleObj.products.length;
    const messageEl = this.querySelector('.progress-bar__messaging .messaging');

    if (productCount !== 0) {
      const tierNumber = parseInt(window.theme.settings.bundleTotalTier);
      const boxes = this.querySelectorAll(`.progress-bar__box`).length;
      let discountAmount = bundleObj.tier !== 0 ? this.querySelector(`.progress-bar__box.discount-box .discount-label[data-tier="${bundleObj.tier}"]`)?.innerText : 0;
      let quantityTo = 0;

      if (bundleObj.tier === 1) {
        quantityTo = productCount < 3 ? 3 - productCount : 2;
        discountAmount = productCount == 3 ? this.querySelector(`.progress-bar__box.discount-box .discount-label[data-tier="2"]`)?.innerText : discountAmount;
      } else if (bundleObj.tier === 2) {
        quantityTo = productCount < 5 ? 5 - productCount : 2;
        discountAmount = productCount == 5 ? this.querySelector(`.progress-bar__box.discount-box .discount-label[data-tier="3"]`)?.innerText : discountAmount;
      } else if (bundleObj.tier === 3) {
        quantityTo = productCount < 7 ? 7 - productCount : 2;
        discountAmount = productCount == 7 ? this.querySelector(`.progress-bar__box.discount-box .discount-label[data-tier="4"]`)?.innerText : discountAmount;
      } else if (bundleObj.tier === 4) {
        quantityTo = productCount < 9 ? 9 - productCount : 2;
      }
console.log(discountAmount)
      const message = bundleObj.tier === tierNumber && productCount === parseInt(boxes)? `Congrats! You get ${discountAmount}` : `add ${quantityTo} more for ${discountAmount}`;
      messageEl.innerHTML = message;
    }
  }

  updateCartProgressBar() {
    let eligibleProducts = JSON.parse(localStorage.getItem('bundleProducts')) ? JSON.parse(localStorage.getItem('bundleProducts')) : {tier: 0, products:[],};
    const contentEl = document.querySelectorAll('.cart-drawer__progress-bar .progress-bar__content');

    contentEl.forEach((content) => {
      const tierNumber = parseInt(window.theme.settings.bundleTotalTier);
      const countEl = parseInt(content.getAttribute('data-count'));
      const tierEl = parseInt(content.getAttribute('data-tier'));
      const productCount = parseInt(eligibleProducts.products.length);

      if (eligibleProducts.tier < tierEl) {
        content.querySelector('.bar-fullfilled')?.setAttribute('data-length', 'false');
      }

      if ((tierNumber === 1 || (tierNumber > 1 && productCount <= 3)) && productCount > 0 && countEl === 3) {
        if (productCount === 1) {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'third');
        } else if (productCount === 2) {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'half');
        } else {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'full');
        }
      } else if ((tierNumber === 2 || (tierNumber > 2 && productCount <= 5)) && productCount > 3  && countEl === 5) {
        document.querySelector('.progress-bar__content[data-count="3"] .bar-fullfilled').setAttribute('data-length', 'full');
        if (productCount === 4) {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'half');
        } else {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'full');
        }
      } else if ((tierNumber === 3 || (tierNumber > 3 && productCount <= 7)) && productCount > 5  && countEl === 7) {
        document.querySelector('.progress-bar__content[data-count="3"] .bar-fullfilled').setAttribute('data-length', 'full');
        document.querySelector('.progress-bar__content[data-count="5"] .bar-fullfilled').setAttribute('data-length', 'full');
        if (productCount === 6) {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'half');
        } else {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'full');
        }
      } else if ((productCount >= 9 || productCount > 7) && countEl === 9) {
        document.querySelector('.progress-bar__content[data-count="3"] .bar-fullfilled').setAttribute('data-length', 'full');
        document.querySelector('.progress-bar__content[data-count="5"] .bar-fullfilled').setAttribute('data-length', 'full');
        document.querySelector('.progress-bar__content[data-count="7"] .bar-fullfilled').setAttribute('data-length', 'full');
        if (productCount === 8) {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'half');
        } else {
          content.querySelector('.bar-fullfilled').setAttribute('data-length', 'full');
        }
      }
    });
  }
}

customElements.define('bundle-collection', BundleCollection);
